import { jsx } from 'react/jsx-runtime';
import { useEffect, createElement } from 'react';
import clsx from 'clsx';
import { useField } from 'formik';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { Text } from '../Text/Text.js';

const OptionsRowField = ({
  name,
  validate,
  options,
  onItemSelect,
  initialValue
}) => {
  const [{
    value,
    ...field
  }, _meta, {
    setValue,
    setError
  }] = useField({
    name,
    validate
  });
  useEffect(() => {
    // Trigger validation when remounting on conditional fields
    setValue(value || initialValue);
    return () => {
      setValue(undefined);
      setError(undefined);
    };
  }, []);
  const onItemClick = (item, index) => {
    setValue(item.value);
    onItemSelect?.(item, index);
  };
  return jsx("div", {
    className: "flex flex-wrap gap-xs",
    children: options.map((item, index) => (/*#__PURE__*/createElement(ButtonBase, {
      ...field,
      key: index,
      type: "button",
      onClick: () => onItemClick(item, index),
      className: clsx('mb-xs rounded-small border border-dashed border-dark-gray p-xs hover:border-green', value === item.value && 'border-solid border-green')
    }, jsx(Text, {
      fontWeight: "semibold",
      className: clsx('text-left text-white', value === item.value && 'text-green'),
      children: item.title
    }))))
  });
};

export { OptionsRowField };
